// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import App from './App'
import router from './router'
import data from './config/data';
import store from './config/store';
import i18n from './i18n';
import VueSlider from 'vue-slider-component';
import Constant from './config/constant';
import Perference from './config/perference';
import MyInfo from "./config/MyInfo";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "./assets/css/app.scss";
import 'vue-slider-component/theme/default.css';
import './assets/css/Slider.scss';

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(Constant);
Vue.use(Perference);
Vue.use(MyInfo);
Vue.use(require('vue-moment'));
Vue.component('vue-slider', VueSlider);
const EventBus = new Vue();
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: {App},
  template: '<App/>',
  data: data,
  store,
  provide: function () {
    return {
      eventBus: new Vue()
    }
  }
});



// WEBPACK FOOTER //
// ./src/main.js